import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withTranslation, Trans } from 'react-i18next';
import qs from 'qs';
import moment from 'moment-timezone';
import {
  Container,
  Dropdown,
  Button,
  Modal,
  Input,
  Label,
  List,
  Table,
  Loader,
  Checkbox,
  Progress,
  Dimmer,
} from 'semantic-ui-react';
import NavBar from '../../../components/NavBar';
import PageNav from '../../../components/PageNav';
import { fetchM } from '../../../actions/fetchM';
import { flashErrorMessage, flashSuccessMessage } from '../../../actions/flash';
import { promptChangesMessage } from '../../../actions/prompt';
import { DEFAULT_PROMPT } from '../../../constants/promptMessages';
import { checkChanges } from '../../../utils/checkChanges';
import valueToText from '../../../utils/valueToText';
import { namespaces, TRANSLATION_FILES } from '../../../constants/translation';

const STEPS = ['Field', 'Bookings', 'Value', 'Review & confirm'];

const BOOKINGS_PAGE_SIZE = 20;

const HISTORY_PAGE_SIZE = 10;

const HISTORY_STATUSES = [
  { text: 'Processing', value: 'new' },
  { text: 'Completed', value: 'completed' },
  { text: 'Partially completed', value: 'partial' },
  { text: 'Failed', value: 'failed' },
];

const CUSTOM_FIELD_TYPE_LABELS = {
  dropdown: 'Dropdown Single',
  dropdown_multi: 'Dropdown Multiple',
};

class CustomEdit extends Component {
  static propTypes = {
    onCheck: PropTypes.func,
    t: PropTypes.func,
  }
  static contextTypes = {
    store: PropTypes.object,
  }
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      projects: [],
      selectedProjectID: null,
      modalOpen: false,
      failedCodesItem: null,
      currentStep: 0,
      customFields: [],
      customFieldsLoading: false,
      fieldSearch: '',
      selectedField: null,
      bookings: [],
      bookingsLoading: false,
      bookingsPage: 1,
      bookingsCount: 0,
      bookingsLimit: 0,
      bookingsOffset: 0,
      selectedBookingIDs: [],
      selectedValueOptionID: null,
      selectedValueOptionIDs: [],
      bookingsInfoCache: {},
      confirmChecked: false,
      submitting: false,
      token: null,
      historyData: [],
      historyLoading: true,
      historyPage: 1,
      historyCount: 0,
      historyLimit: 0,
      historyOffset: 0,
      historyOngoing: false,
    };
  }
  componentDidMount() {
    this.fetchProjects();
    this.fetchHistory(1);
    this.historyTicker = setInterval(() => {
      if (this.state.historyOngoing) {
        this.fetchHistory(this.state.historyPage, true);
      }
    }, 5000);
  }
  componentWillUnmount() {
    if (this.historyTicker) {
      clearInterval(this.historyTicker);
    }
  }
  getFieldValueDisplay(bookingCustomFields) {
    const { selectedField } = this.state;
    const bcf = (bookingCustomFields || []).find(f => (
      f.projectBookingCustomFieldID === selectedField.id
    ));
    if (!bcf) return '—';
    if (selectedField.type === 'dropdown_multi') {
      const optionIDs = bcf.projectBookingCustomFieldOptionIDs || [];
      const titles = (bcf.projectBookingCustomFieldOptions || [])
        .filter(o => optionIDs.includes(o.id))
        .map(o => o.title);
      return titles.length > 0 ? titles.join(', ') : '—';
    }
    const option = (bcf.projectBookingCustomFieldOptions || []).find(o => (
      o.id === bcf.projectBookingCustomFieldOptionID
    ));
    return (option && option.title) || bcf.value || '—';
  }
  handleBackClick = () => {
    this.setState({ selectedProjectID: null, customFields: [], fieldSearch: '' });
    if (this.props.onCheck) {
      this.props.onCheck(false);
    }
  }
  handleChangeFieldClick = () => {
    this.setState({
      selectedField: null,
      bookings: [],
      currentStep: 0,
      selectedValueOptionID: null,
      selectedValueOptionIDs: [],
    });
  }
  handleEditClick = () => {
    if (this.state.historyOngoing) return;
    this.setState({ modalOpen: true, currentStep: 0 });
  }
  handleFieldClick = (field) => {
    this.setState({
      selectedField: field,
      currentStep: 1,
      selectedBookingIDs: [],
      selectedValueOptionID: null,
      selectedValueOptionIDs: [],
    }, () => {
      this.fetchProjectBookings(1);
    });
  }
  handleFieldSearchChange = (e, { value }) => {
    this.setState({ fieldSearch: value });
  }
  handleFooterBackClick = () => {
    const { currentStep, selectedProjectID } = this.state;
    if (currentStep === 3) {
      this.setState({ currentStep: 2 });
    } else if (currentStep === 2) {
      this.setState({ currentStep: 1 });
    } else if (currentStep === 1) {
      this.handleChangeFieldClick();
    } else if (currentStep === 0 && selectedProjectID) {
      this.handleBackClick();
    }
  }
  handleCheckBeforeClose = () => {
    if (this.state.selectedProjectID) {
      const { t } = this.props;
      const { store } = this.context;
      const callback = () => this.closeModal();
      store.dispatch(promptChangesMessage({
        message: t(DEFAULT_PROMPT, { ns: TRANSLATION_FILES.translation }),
        callback,
      }));
      return true;
    }
    return false;
  }
  handleModalClose = () => {
    if (!this.handleCheckBeforeClose()) {
      this.closeModal();
    }
  }
  handleNextClick = () => {
    const { currentStep } = this.state;
    if (currentStep === 1) {
      this.setState({ currentStep: 2 });
    } else if (currentStep === 2) {
      this.setState({ currentStep: 3, confirmChecked: false });
    }
  }
  handleConfirmCheckChange = (e, { checked }) => {
    this.setState({ confirmChecked: checked });
  }
  handleConfirmSubmitClick = () => {
    this.submitBulkEdit();
  }
  handlePageChange = (currentPage) => {
    this.setState({ bookingsPage: currentPage }, () => {
      this.fetchProjectBookings(currentPage);
    });
  }
  handleFailedCodesOpen = (item) => {
    this.setState({ failedCodesItem: item });
  }
  handleFailedCodesClose = () => {
    this.setState({ failedCodesItem: null });
  }
  handleHistoryPageChange = (currentPage) => {
    this.setState({ historyPage: currentPage }, () => {
      this.fetchHistory(currentPage);
    });
  }
  progressToPercent = (item) => {
    let percent = 0;
    if (item.progress && item.progress.includes('/')) {
      const data = item.progress.split('/');
      const percentFor = parseInt(data[0], 10);
      const percentOf = parseInt(data[1], 10);
      if (percentOf > 0) {
        percent = Math.floor((percentFor / percentOf) * 100);
      }
    }
    return percent;
  }
  handleProjectChange = (e, { value }) => {
    this.setState({ selectedProjectID: value, customFields: [] }, () => {
      if (value) {
        this.fetchCustomFields(value);
      }
    });
    if (this.props.onCheck) {
      this.props.onCheck(!!value);
    }
  }
  handleSelectAllChange = (e, { checked }) => {
    const { bookings, selectedBookingIDs } = this.state;
    const pageIDs = bookings.map(booking => booking.id);
    this.setState({
      selectedBookingIDs: checked
        ? Array.from(new Set([...selectedBookingIDs, ...pageIDs]))
        : selectedBookingIDs.filter(id => !pageIDs.includes(id)),
    });
  }
  handleSelectBookingChange = (bookingID) => {
    const { selectedBookingIDs } = this.state;
    const isSelected = selectedBookingIDs.includes(bookingID);
    this.setState({
      selectedBookingIDs: isSelected
        ? selectedBookingIDs.filter(id => id !== bookingID)
        : [...selectedBookingIDs, bookingID],
    });
  }
  handleValueOptionClick = (optionID) => {
    this.setState({ selectedValueOptionID: optionID });
  }
  handleValueOptionToggle = (optionID) => {
    const { selectedValueOptionIDs } = this.state;
    const isSelected = selectedValueOptionIDs.includes(optionID);
    this.setState({
      selectedValueOptionIDs: isSelected
        ? selectedValueOptionIDs.filter(id => id !== optionID)
        : [...selectedValueOptionIDs, optionID],
    });
  }
  closeModal() {
    this.setState({
      modalOpen: false,
      currentStep: 0,
      selectedProjectID: null,
      customFields: [],
      fieldSearch: '',
      selectedField: null,
      bookings: [],
      bookingsPage: 1,
      bookingsCount: 0,
      bookingsLimit: 0,
      bookingsOffset: 0,
      selectedBookingIDs: [],
      selectedValueOptionID: null,
      selectedValueOptionIDs: [],
      bookingsInfoCache: {},
      confirmChecked: false,
      submitting: false,
    });
    if (this.props.onCheck) {
      this.props.onCheck(false);
    }
  }
  async fetchCustomFields(projectID) {
    this.setState({ customFieldsLoading: true });
    const { store } = this.context;
    const { t } = this.props;
    let res;
    try {
      res = await store.dispatch(fetchM(`/projects/${projectID}/booking_custom_fields/`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (e) {
      await store.dispatch(flashErrorMessage({ message: t('An error occurred, please refresh page', { ns: TRANSLATION_FILES.translation }) }));
      this.setState({ customFieldsLoading: false });
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
      this.setState({ customFieldsLoading: false });
      return;
    }
    const dropdownTypes = ['dropdown', 'dropdown_multi'];
    const allFields = (await res.json()) || [];
    const customFields = allFields.filter(field => (
      dropdownTypes.includes(field.type) && !field.isDefault
    ));
    this.setState({ customFields, customFieldsLoading: false });
  }
  async fetchProjectBookings(page = 1) {
    this.setState({ bookingsLoading: true, bookings: [] });
    const { store } = this.context;
    const { t } = this.props;
    const { selectedProjectID } = this.state;
    const query = {
      projectFilter: btoa(selectedProjectID),
      includeCustomFields: true,
      limit: BOOKINGS_PAGE_SIZE,
      page,
    };
    let res;
    try {
      res = await store.dispatch(fetchM(`/bookings/?${qs.stringify(query)}`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (e) {
      await store.dispatch(flashErrorMessage({ message: t('An error occurred, please refresh page', { ns: TRANSLATION_FILES.translation }) }));
      this.setState({ bookingsLoading: false });
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
      this.setState({ bookingsLoading: false });
      return;
    }
    const count = parseInt(res.headers.get('M-Data-count'), 10) || 0;
    const limit = parseInt(res.headers.get('M-Data-limit'), 10) || 0;
    const offset = parseInt(res.headers.get('M-Data-offset'), 10) || 0;
    const token = res.headers.get('X-Csrf-Token');
    const bookingsList = (await res.json()) || [];
    const bookings = bookingsList.map(booking => ({
      id: booking.id,
      bookingCode: booking.code || '—',
      unitReference: (booking.projectUnit && booking.projectUnit.reference) || '—',
      customerName: (booking.bookingCustomer && booking.bookingCustomer.name) || '—',
      statusName: (booking.bookingStatus && booking.bookingStatus.name) || '—',
      fieldValue: this.getFieldValueDisplay(booking.bookingCustomFields),
    }));
    const bookingsInfoCache = { ...this.state.bookingsInfoCache };
    bookings.forEach((booking) => {
      bookingsInfoCache[booking.id] = booking;
    });
    this.setState({
      bookings,
      bookingsLoading: false,
      bookingsCount: count,
      bookingsLimit: limit,
      bookingsOffset: offset,
      bookingsInfoCache,
      token,
    });
  }
  async submitBulkEdit() {
    this.setState({ submitting: true });
    const { store } = this.context;
    const { t } = this.props;
    const {
      selectedProjectID, selectedField, selectedBookingIDs,
      selectedValueOptionID, selectedValueOptionIDs, token,
    } = this.state;
    const isMulti = selectedField.type === 'dropdown_multi';
    const body = {
      projectID: selectedProjectID,
      projectBookingCustomFieldID: selectedField.id,
      bookingIDs: selectedBookingIDs,
      projectBookingCustomFieldOptionID: isMulti ? '' : selectedValueOptionID,
      projectBookingCustomFieldOptionIDs: isMulti ? selectedValueOptionIDs : [],
    };
    let res;
    try {
      res = await store.dispatch(fetchM('/bookings/custom_fields/bulk/', {
        credentials: 'include',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': token,
        },
        body: JSON.stringify(body),
      }));
    } catch (e) {
      await store.dispatch(flashErrorMessage({ message: t('An error occurred, please refresh page', { ns: TRANSLATION_FILES.translation }) }));
      this.setState({ submitting: false });
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
      this.setState({ submitting: false });
      return;
    }
    this.setState({ submitting: false }, () => {
      store.dispatch(flashSuccessMessage({ message: t('Bulk edit has been queued', { ns: TRANSLATION_FILES.screens }) }));
      this.closeModal();
      this.setState({ historyPage: 1 }, () => {
        this.fetchHistory(1);
      });
    });
  }
  async fetchProjects() {
    this.setState({ loading: true });
    const { store } = this.context;
    const { t } = this.props;
    const query = Object.assign({
      limit: 0,
      showAsOptions: true,
    });
    let res;
    try {
      res = await store.dispatch(fetchM(`/projects/?${qs.stringify(query)}`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (e) {
      await store.dispatch(flashErrorMessage({ message: t('An error occurred, please refresh page', { ns: TRANSLATION_FILES.translation }) }));
      this.setState({ loading: false });
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
      this.setState({ loading: false });
      return;
    }
    const projects = (await res.json()) || [];
    this.setState({ projects, loading: false });
  }
  async fetchHistory(page = 1, silent = false) {
    if (!silent) this.setState({ historyLoading: true });
    const { store } = this.context;
    const { t } = this.props;
    const query = { page, limit: HISTORY_PAGE_SIZE };
    let res;
    try {
      res = await store.dispatch(fetchM(`/bookings/custom_fields/bulk/?${qs.stringify(query)}`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (e) {
      if (!silent) {
        await store.dispatch(flashErrorMessage({ message: t('An error occurred, please refresh page', { ns: TRANSLATION_FILES.translation }) }));
        this.setState({ historyLoading: false });
      }
      return;
    }
    if (!res.ok) {
      if (!silent) {
        const message = await res.text();
        await store.dispatch(flashErrorMessage({ message }));
        this.setState({ historyLoading: false });
      }
      return;
    }
    const count = parseInt(res.headers.get('M-Data-count'), 10) || 0;
    const limit = parseInt(res.headers.get('M-Data-limit'), 10) || 0;
    const offset = parseInt(res.headers.get('M-Data-offset'), 10) || 0;
    const historyData = (await res.json()) || [];
    const historyOngoing = historyData.some(item => item.statusID === 'new');
    this.setState({
      historyData,
      historyLoading: false,
      historyCount: count,
      historyLimit: limit,
      historyOffset: offset,
      historyOngoing,
    });
  }
  renderFieldSelect() {
    const {
      customFields, customFieldsLoading, fieldSearch, projects, selectedProjectID,
    } = this.state;
    const { t } = this.props;
    const selectedProject = (projects || []).find(project => project.id === selectedProjectID);
    const filteredFields = (customFields || []).filter(field => (
      (field.label || field.name || '').toLowerCase().includes(fieldSearch.toLowerCase())
    ));
    return (
      <React.Fragment>
        {selectedProject && (
          <p>
            {t('Project', { ns: TRANSLATION_FILES.screens })}: <strong>{selectedProject.name}</strong>
          </p>
        )}
        <Input
          fluid
          icon="search"
          iconPosition="left"
          placeholder={t('Search custom fields', { ns: TRANSLATION_FILES.screens })}
          value={fieldSearch}
          loading={customFieldsLoading}
          onChange={this.handleFieldSearchChange}
        />
        <List
          divided
          selection
          style={{ marginTop: '1em', maxHeight: '18em', overflowY: 'auto' }}
        >
          {filteredFields.length === 0 ? (
            <p>{t('No custom field with dropdown found', { ns: TRANSLATION_FILES.screens })}</p>
          ) : filteredFields.map(field => (
            <List.Item key={field.id} onClick={() => this.handleFieldClick(field)}>
              <List.Content floated="right">
                <Label>
                  {CUSTOM_FIELD_TYPE_LABELS[field.type]
                    ? t(CUSTOM_FIELD_TYPE_LABELS[field.type], { ns: TRANSLATION_FILES.constants })
                    : field.type}
                </Label>
              </List.Content>
              <List.Content>{field.label}</List.Content>
            </List.Item>
          ))}
        </List>
      </React.Fragment>
    );
  }
  renderBookingsList() {
    const {
      selectedField, bookings, bookingsLoading, bookingsPage,
      bookingsCount, bookingsLimit, bookingsOffset, selectedBookingIDs,
    } = this.state;
    const { t } = this.props;
    const allSelected = bookings.length > 0
      && bookings.every(b => selectedBookingIDs.includes(b.id));
    return (
      <React.Fragment>
        <div
          style={{
            background: '#e9f7f1', padding: '0.75em 1em', borderRadius: 4, marginBottom: '1em',
          }}
        >
          {t('Editing', { ns: TRANSLATION_FILES.screens })} <strong>{selectedField.label}</strong> —{' '}
          <a role="button" tabIndex={0} onClick={this.handleChangeFieldClick}>{t('change field', { ns: TRANSLATION_FILES.screens })}</a>
        </div>
        {bookingsLoading && <Loader active inline="centered" />}
        {!bookingsLoading && bookings.length === 0 && <p>{t('No bookings found', { ns: TRANSLATION_FILES.screens })}</p>}
        {!bookingsLoading && bookings.length > 0 && (
          <React.Fragment>
            <div className="bulk-edit-desktop-table">
              <Table celled selectable>
                <Table.Header>
                  <Table.Row>
                    <Table.HeaderCell collapsing>
                      <Checkbox checked={allSelected} onChange={this.handleSelectAllChange} />
                    </Table.HeaderCell>
                    <Table.HeaderCell>{t('Code', { ns: TRANSLATION_FILES.screens })}</Table.HeaderCell>
                    <Table.HeaderCell>{t('Unit', { ns: TRANSLATION_FILES.screens })}</Table.HeaderCell>
                    <Table.HeaderCell>{t('Customer', { ns: TRANSLATION_FILES.screens })}</Table.HeaderCell>
                    <Table.HeaderCell>{t('Status', { ns: TRANSLATION_FILES.screens })}</Table.HeaderCell>
                    <Table.HeaderCell>{selectedField.label}</Table.HeaderCell>
                  </Table.Row>
                </Table.Header>
                <Table.Body>
                  {bookings.map(booking => (
                    <Table.Row key={booking.id}>
                      <Table.Cell collapsing>
                        <Checkbox
                          checked={selectedBookingIDs.includes(booking.id)}
                          onChange={() => this.handleSelectBookingChange(booking.id)}
                        />
                      </Table.Cell>
                      <Table.Cell>{booking.bookingCode}</Table.Cell>
                      <Table.Cell>{booking.unitReference}</Table.Cell>
                      <Table.Cell>{booking.customerName}</Table.Cell>
                      <Table.Cell>
                        {t(booking.statusName, { ns: TRANSLATION_FILES.constants })}
                      </Table.Cell>
                      <Table.Cell>{booking.fieldValue}</Table.Cell>
                    </Table.Row>
                  ))}
                </Table.Body>
              </Table>
            </div>
            <div className="bulk-edit-mobile-list">
              {bookings.map(booking => (
                <div className="bulk-edit-mobile-card" key={booking.id}>
                  <div className="bulk-edit-mobile-card-header">
                    <Checkbox
                      checked={selectedBookingIDs.includes(booking.id)}
                      onChange={() => this.handleSelectBookingChange(booking.id)}
                    />
                    <strong>{booking.bookingCode}</strong>
                  </div>
                  <div className="bulk-edit-mobile-card-row">
                    <span>{t('Unit', { ns: TRANSLATION_FILES.screens })}</span>
                    <span>{booking.unitReference}</span>
                  </div>
                  <div className="bulk-edit-mobile-card-row">
                    <span>{t('Customer', { ns: TRANSLATION_FILES.screens })}</span>
                    <span>{booking.customerName}</span>
                  </div>
                  <div className="bulk-edit-mobile-card-row">
                    <span>{t('Status', { ns: TRANSLATION_FILES.screens })}</span>
                    <span>
                      {t(booking.statusName, { ns: TRANSLATION_FILES.constants })}
                    </span>
                  </div>
                  <div className="bulk-edit-mobile-card-row">
                    <span>{selectedField.label}</span>
                    <span>{booking.fieldValue}</span>
                  </div>
                </div>
              ))}
            </div>
            <PageNav
              currentPage={bookingsPage}
              count={bookingsCount}
              limit={bookingsLimit}
              offset={bookingsOffset}
              dataSize={bookings.length}
              loading={bookingsLoading}
              onChange={this.handlePageChange}
            />
          </React.Fragment>
        )}
      </React.Fragment>
    );
  }
  renderValueSelect() {
    const {
      selectedField, selectedBookingIDs, selectedValueOptionID, selectedValueOptionIDs,
    } = this.state;
    const { t } = this.props;
    const fieldOptions = selectedField.projectBookingCustomFieldOptions || [];
    const isMulti = selectedField.type === 'dropdown_multi';
    return (
      <React.Fragment>
        <div
          style={{
            background: '#e9f7f1', padding: '0.75em 1em', borderRadius: 4, marginBottom: '1em',
          }}
        >
          {t('Editing', { ns: TRANSLATION_FILES.screens })} <strong>{selectedField.label}</strong> —{' '}
          <a role="button" tabIndex={0} onClick={this.handleChangeFieldClick}>{t('change field', { ns: TRANSLATION_FILES.screens })}</a>
        </div>
        <p>
          <Trans
            ns={TRANSLATION_FILES.screens}
            i18nKey="Setting <strong>{{field}}</strong> for <strong>{{count}}</strong> selected {{bookingLabel}}."
            values={{
              field: selectedField.label,
              count: selectedBookingIDs.length,
              bookingLabel: selectedBookingIDs.length === 1 ? 'booking' : 'bookings',
            }}
          >
            {'Setting <strong>{{field}}</strong> for <strong>{{count}}</strong> selected {{bookingLabel}}.'}
          </Trans>
        </p>
        <Label style={{ marginBottom: '0.5em' }}>{t('New Value', { ns: TRANSLATION_FILES.screens })}</Label>
        <div style={{ display: 'flex', gap: '0.75em', flexWrap: 'wrap' }}>
          {fieldOptions.map((option) => {
            const isSelected = isMulti
              ? selectedValueOptionIDs.includes(option.id)
              : selectedValueOptionID === option.id;
            return (
              <Button
                key={option.id}
                basic={!isSelected}
                color={isSelected ? 'green' : undefined}
                onClick={() => (isMulti
                  ? this.handleValueOptionToggle(option.id)
                  : this.handleValueOptionClick(option.id))}
              >
                {option.title}
              </Button>
            );
          })}
        </div>
      </React.Fragment>
    );
  }
  renderReviewConfirm() {
    const {
      selectedField, selectedBookingIDs, selectedValueOptionID,
      selectedValueOptionIDs, bookingsInfoCache, confirmChecked,
    } = this.state;
    const { t } = this.props;
    const isMulti = selectedField.type === 'dropdown_multi';
    const fieldOptions = selectedField.projectBookingCustomFieldOptions || [];
    const newValueLabel = isMulti
      ? fieldOptions.filter(o => selectedValueOptionIDs.includes(o.id)).map(o => o.title).join(', ')
      : ((fieldOptions.find(o => o.id === selectedValueOptionID) || {}).title || '—');
    return (
      <React.Fragment>
        <p>
          <Trans
            ns={TRANSLATION_FILES.screens}
            i18nKey='You are about to set <strong>{{field}}</strong> = "{{value}}" for <strong>{{count}}</strong> selected {{bookingLabel}}.'
            values={{
              field: selectedField.label,
              value: newValueLabel,
              count: selectedBookingIDs.length,
              bookingLabel: selectedBookingIDs.length === 1 ? 'booking' : 'bookings',
            }}
          >
            {'You are about to set <strong>{{field}}</strong> = "{{value}}" for <strong>{{count}}</strong> selected {{bookingLabel}}.'}
          </Trans>
        </p>
        <div style={{ maxHeight: '16em', overflowY: 'auto' }}>
          <div className="bulk-edit-desktop-table">
            <Table celled>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell>{t('Code', { ns: TRANSLATION_FILES.screens })}</Table.HeaderCell>
                  <Table.HeaderCell>{t('Unit', { ns: TRANSLATION_FILES.screens })}</Table.HeaderCell>
                  <Table.HeaderCell>{t('Customer', { ns: TRANSLATION_FILES.screens })}</Table.HeaderCell>
                  <Table.HeaderCell>{t('Current', { ns: TRANSLATION_FILES.screens })}</Table.HeaderCell>
                  <Table.HeaderCell>{t('New', { ns: TRANSLATION_FILES.screens })}</Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                {selectedBookingIDs.map((id) => {
                  const info = bookingsInfoCache[id] || {};
                  return (
                    <Table.Row key={id}>
                      <Table.Cell>{info.bookingCode || '—'}</Table.Cell>
                      <Table.Cell>{info.unitReference || '—'}</Table.Cell>
                      <Table.Cell>{info.customerName || '—'}</Table.Cell>
                      <Table.Cell><s>{info.fieldValue || '—'}</s></Table.Cell>
                      <Table.Cell><Label color="green">{newValueLabel}</Label></Table.Cell>
                    </Table.Row>
                  );
                })}
              </Table.Body>
            </Table>
          </div>
          <div className="bulk-edit-mobile-list">
            {selectedBookingIDs.map((id) => {
              const info = bookingsInfoCache[id] || {};
              return (
                <div className="bulk-edit-mobile-card" key={id}>
                  <div className="bulk-edit-mobile-card-header">
                    <strong>{info.bookingCode || '—'}</strong>
                    <Label color="green">{newValueLabel}</Label>
                  </div>
                  <div className="bulk-edit-mobile-card-row">
                    <span>{t('Unit', { ns: TRANSLATION_FILES.screens })}</span>
                    <span>{info.unitReference || '—'}</span>
                  </div>
                  <div className="bulk-edit-mobile-card-row">
                    <span>{t('Customer', { ns: TRANSLATION_FILES.screens })}</span>
                    <span>{info.customerName || '—'}</span>
                  </div>
                  <div className="bulk-edit-mobile-card-row">
                    <span>{t('Current', { ns: TRANSLATION_FILES.screens })}</span>
                    <span><s>{info.fieldValue || '—'}</s></span>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
        <Checkbox
          checked={confirmChecked}
          onChange={this.handleConfirmCheckChange}
          label={t('I understand this change applies to all eligible bookings shown above and will be recorded in the Bulk Edit History log.', { ns: TRANSLATION_FILES.screens })}
          style={{ marginTop: '1em' }}
        />
      </React.Fragment>
    );
  }
  renderHistoryProgress(item) {
    const { t } = this.props;
    return (
      <div>
        <Progress
          size="small"
          percent={this.progressToPercent(item)}
          progress
          color={item.statusID === 'new' ? 'blue' : null}
          success={item.statusID === 'completed'}
          warning={item.statusID === 'partial'}
          error={item.statusID === 'failed'}
          active={item.statusID === 'new'}
        >
          {t(valueToText(HISTORY_STATUSES, item.statusID), { ns: TRANSLATION_FILES.screens })}
          {item.progress ? ` (${item.progress})` : ''}
        </Progress>
        {this.renderFailedCodesLink(item)}
      </div>
    );
  }
  renderFailedCodesLink(item) {
    const { t } = this.props;
    const failedCodes = item.failedBookingCodes || [];
    if (failedCodes.length === 0) return null;
    return (
      <a
        className="bulk-edit-history-failed-codes"
        role="button"
        tabIndex={0}
        onClick={() => this.handleFailedCodesOpen(item)}
        onKeyPress={() => this.handleFailedCodesOpen(item)}
      >
        {t('View {{count}} failed bookings', { count: failedCodes.length, ns: TRANSLATION_FILES.screens })}
      </a>
    );
  }
  renderFailedCodesModal() {
    const { t } = this.props;
    const { failedCodesItem } = this.state;
    const failedCodes = (failedCodesItem && failedCodesItem.failedBookingCodes) || [];
    return (
      <Modal open={!!failedCodesItem} onClose={this.handleFailedCodesClose} size="tiny" closeIcon>
        <Modal.Header>
          {t('Failed bookings', { ns: TRANSLATION_FILES.screens })}
          {failedCodesItem && failedCodesItem.fieldLabel ? ` · ${failedCodesItem.fieldLabel}` : ''}
        </Modal.Header>
        <Modal.Content>
          <p>
            {t('These bookings could not be updated.', { ns: TRANSLATION_FILES.screens })}
          </p>
          <div className="bulk-edit-failed-codes-list">
            <List divided relaxed>
              {failedCodes.map((code, index) => (
                <List.Item key={`${code}-${index}`}>{code}</List.Item>
              ))}
            </List>
          </div>
        </Modal.Content>
        <Modal.Actions>
          <Button primary content={t('Close', { ns: TRANSLATION_FILES.translation })} onClick={this.handleFailedCodesClose} />
        </Modal.Actions>
      </Modal>
    );
  }
  renderHistoryTable() {
    const {
      historyData, historyLoading, historyPage, historyCount, historyLimit, historyOffset,
    } = this.state;
    const { t } = this.props;
    return (
      <React.Fragment>
        <Dimmer inverted active={historyLoading}>
          <Loader inline="centered">{t('Loading', { ns: TRANSLATION_FILES.translation })}</Loader>
        </Dimmer>
        <div className="bulk-edit-history-desktop">
          <Table>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>{t('Created By', { ns: TRANSLATION_FILES.screens })}</Table.HeaderCell>
                <Table.HeaderCell>{t('Project', { ns: TRANSLATION_FILES.screens })}</Table.HeaderCell>
                <Table.HeaderCell>{t('Custom Field', { ns: TRANSLATION_FILES.screens })}</Table.HeaderCell>
                <Table.HeaderCell>{t('Created At', { ns: TRANSLATION_FILES.screens })}</Table.HeaderCell>
                <Table.HeaderCell>{t('Progress', { ns: TRANSLATION_FILES.screens })}</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {historyData && historyData.length > 0 ? (
                historyData.map(item => (
                  <Table.Row key={item.id}>
                    <Table.Cell>{item.userName || '—'}</Table.Cell>
                    <Table.Cell>{item.projectName || '—'}</Table.Cell>
                    <Table.Cell>{item.fieldLabel || '—'}</Table.Cell>
                    <Table.Cell collapsing>
                      {moment(item.createdAt).format('MMMM Do YYYY, h:mm a')}
                    </Table.Cell>
                    <Table.Cell width={4}>
                      {this.renderHistoryProgress(item)}
                    </Table.Cell>
                  </Table.Row>
                ))
              ) : (
                <Table.Row>
                  <Table.Cell colSpan={5} textAlign="center">
                    {t('No bulk edit history found', { ns: TRANSLATION_FILES.screens })}.
                  </Table.Cell>
                </Table.Row>
              )}
            </Table.Body>
            <Table.Footer>
              <Table.Row>
                <Table.HeaderCell colSpan={5} textAlign="center">
                  <PageNav
                    currentPage={historyPage}
                    count={historyCount}
                    limit={historyLimit}
                    offset={historyOffset}
                    dataSize={(historyData && historyData.length) || 0}
                    loading={historyLoading}
                    onChange={this.handleHistoryPageChange}
                  />
                </Table.HeaderCell>
              </Table.Row>
            </Table.Footer>
          </Table>
        </div>
        <div className="bulk-edit-history-mobile">
          {historyData && historyData.length > 0 ? historyData.map(item => (
            <div className="bulk-edit-history-card" key={item.id}>
              <div className="bulk-edit-history-card-row">
                <span>{t('Created By', { ns: TRANSLATION_FILES.screens })}</span>
                <strong>{item.userName || '—'}</strong>
              </div>
              <div className="bulk-edit-history-card-row">
                <span>{t('Project', { ns: TRANSLATION_FILES.screens })}</span>
                <span>{item.projectName || '—'}</span>
              </div>
              <div className="bulk-edit-history-card-row">
                <span>{t('Custom Field', { ns: TRANSLATION_FILES.screens })}</span>
                <span>{item.fieldLabel || '—'}</span>
              </div>
              <div className="bulk-edit-history-card-row">
                <span>{t('Created At', { ns: TRANSLATION_FILES.screens })}</span>
                <span>{moment(item.createdAt).format('MMMM Do YYYY, h:mm a')}</span>
              </div>
              {this.renderHistoryProgress(item)}
            </div>
          )) : (
            <p>{t('No bulk edit history found', { ns: TRANSLATION_FILES.screens })}.</p>
          )}
          <PageNav
            currentPage={historyPage}
            count={historyCount}
            limit={historyLimit}
            offset={historyOffset}
            dataSize={(historyData && historyData.length) || 0}
            loading={historyLoading}
            onChange={this.handleHistoryPageChange}
          />
        </div>
      </React.Fragment>
    );
  }
  renderModalContent() {
    const {
      selectedProjectID, projects, selectedField, currentStep,
    } = this.state;
    const { t } = this.props;
    const options = (projects || []).map(project => ({
      key: project.id,
      value: project.id,
      text: project.name,
    }));
    if (!selectedProjectID) {
      return (
        <Dropdown
          placeholder={t('Select Project', { ns: TRANSLATION_FILES.screens })}
          fluid
          selection
          search
          options={options}
          value={selectedProjectID}
          onChange={this.handleProjectChange}
        />
      );
    }
    if (!selectedField) {
      return this.renderFieldSelect();
    }
    if (currentStep === 3) {
      return this.renderReviewConfirm();
    }
    if (currentStep === 2) {
      return this.renderValueSelect();
    }
    return this.renderBookingsList();
  }
  render() {
    const {
      modalOpen, currentStep, selectedProjectID,
      selectedBookingIDs, selectedField, selectedValueOptionID, selectedValueOptionIDs,
      confirmChecked, submitting, historyOngoing,
    } = this.state;
    const { t } = this.props;
    let nextDisabled = true;
    if (selectedProjectID) {
      if (currentStep === 1) {
        nextDisabled = selectedBookingIDs.length === 0;
      } else if (currentStep === 2) {
        nextDisabled = selectedField.type === 'dropdown_multi'
          ? selectedValueOptionIDs.length === 0
          : !selectedValueOptionID;
      }
    }
    return (
      <Container>
        <NavBar
          header={t('Bulk Edit Custom Fields', { ns: TRANSLATION_FILES.screens })}
          rightNav={(
            <Button
              primary
              disabled={historyOngoing}
              title={historyOngoing ? t('A bulk edit is currently in progress', { ns: TRANSLATION_FILES.screens }) : undefined}
              onClick={this.handleEditClick}
            >
              {t('Begin Bulk Edit', { ns: TRANSLATION_FILES.screens })}
            </Button>
          )}
        />
        {this.renderHistoryTable()}
        {this.renderFailedCodesModal()}
        <Modal className="bulk-edit-modal" open={modalOpen} onClose={this.handleModalClose} size="large" closeIcon>
          <Modal.Header>{t('Bulk Edit Custom Fields', { ns: TRANSLATION_FILES.screens })}</Modal.Header>
          <Modal.Content>
            <div style={{ marginBottom: '1em' }}>
              {STEPS.map((step, index) => (
                <Label
                  key={step}
                  circular
                  color={index === currentStep ? 'green' : undefined}
                  style={{ marginRight: '0.5em' }}
                >
                  {index + 1} · {t(step, { ns: TRANSLATION_FILES.screens })}
                </Label>
              ))}
            </div>
            {this.renderModalContent()}
          </Modal.Content>
          <Modal.Actions>
            {(currentStep > 0 || selectedProjectID) && (
              <Button floated="left" onClick={this.handleFooterBackClick}>{t('Back', { ns: TRANSLATION_FILES.translation })}</Button>
            )}
            {currentStep === 3 ? (
              <React.Fragment>
                <Button onClick={this.handleModalClose}>{t('Cancel', { ns: TRANSLATION_FILES.translation })}</Button>
                <Button
                  color="teal"
                  disabled={!confirmChecked}
                  loading={submitting}
                  onClick={this.handleConfirmSubmitClick}
                >
                  {t('Confirm & Apply', { ns: TRANSLATION_FILES.screens })}
                </Button>
              </React.Fragment>
            ) : (
              <Button primary disabled={nextDisabled} onClick={this.handleNextClick}>{t('Next', { ns: TRANSLATION_FILES.screens })}</Button>
            )}
          </Modal.Actions>
        </Modal>
      </Container>
    );
  }
}

export default withTranslation(namespaces)(checkChanges(CustomEdit));



// WEBPACK FOOTER //
// ./src/containers/Bookings/customEdit/CustomEdit.jsx